import ComponentTypePages from "@/pages/configurations/componentTypes";
import LadleHeatMetrics from "@/pages/configurations/ladleHeatMetrics";
import LadleTapTempAlertPage from "@/pages/configurations/ladleTapTempAlert";
import LocationPage from "@/pages/configurations/locations";
import PartsPage from "@/pages/configurations/parts";
import RootPage from "@/pages/configurations/roots";
import { Snapshots } from "@/pages/configurations/snapshots";
import TundishAlarmsPage from "@/pages/configurations/tundishAlarms";
import TundishHeatMetrics from "@/pages/configurations/tundishHeatMetrics";
import UpdateDressCache from "@/pages/configurations/updateDressCache";
import VendorsPage from "@/pages/configurations/vendors";
import WorkerTypesPage from "@/pages/configurations/workerTypes";
import WorkersPage from "@/pages/configurations/workers";
import { MenuItem, MenuList } from "@material-ui/core";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

type Component = {
	path: string;
	sidebar: () => ReactNode;
	main: () => ReactNode;
};

const components: Component[] = [
	{
		path: "workers",
		sidebar: () => <div>Workers</div>,
		main: () => <WorkersPage />,
	},
	{
		path: "workerTypes",
		sidebar: () => <div>Worker Types</div>,
		main: () => <WorkerTypesPage />,
	},
	{
		path: "vendors",
		sidebar: () => <div>Vendors</div>,
		main: () => <VendorsPage />,
	},
	{
		path: "component-types",
		sidebar: () => <div>ComponentType</div>,
		main: () => <ComponentTypePages />,
	},
	{
		path: "parts",
		sidebar: () => <div>Parts</div>,
		main: () => <PartsPage />,
	},
	{
		path: "locations",
		sidebar: () => <div>Locations</div>,
		main: () => <LocationPage />,
	},
	{
		path: "roots",
		sidebar: () => <>Roots</>,
		main: () => <RootPage />,
	},
	{
		path: "ladle-heat-metrics",
		sidebar: () => <>Ladle Heat Metrics</>,
		main: () => <LadleHeatMetrics />,
	},
	{
		path: "tundish-heat-metrics",
		sidebar: () => <>Tundish Heat Metrics</>,
		main: () => <TundishHeatMetrics />,
	},
	{
		path: "alarms/tundishes",
		sidebar: () => <>Tundish Alarms</>,
		main: () => <TundishAlarmsPage />,
	},
	{
		path: "alarms/ladle-tap-temp",
		sidebar: () => <>Ladle Tap Temp Alert</>,
		main: () => <LadleTapTempAlertPage />,
	},
	{
		path: "dress-cache",
		sidebar: () => <>Update Dress Cache</>,
		main: () => <UpdateDressCache />,
	},
	{
		path: "snapshots",
		sidebar: () => <span>Snapshots</span>,
		main: () => <Snapshots />,
	},
];

const sidebar = ({ option }: { option: string }) => (
	<>
		<h3 className="mes-menu-group">Workers</h3>
		<MenuList className="mes-submenu">
			<MenuItem selected={option === "workers"} className="p-0">
				<Link to="/configuration/workers" className="nav-link">
					Workers
				</Link>
			</MenuItem>
		</MenuList>
		<h3 className="mes-menu-group">Vendors</h3>
		<MenuList className="mes-submenu">
			<MenuItem selected={option === "vendors"} className="p-0">
				<Link to="/configuration/vendors" className="nav-link">
					Vendors
				</Link>
			</MenuItem>
		</MenuList>
		<h3 className="mes-menu-group">Parts</h3>

		<MenuList className="mes-submenu">
			<MenuItem selected={option === "roots"} className="p-0">
				<Link to="/configuration/roots" className="nav-link">
					Roots
				</Link>
			</MenuItem>
			<MenuItem selected={option === "component-types"} className="p-0">
				<Link to="/configuration/component-types" className="nav-link">
					Component Types
				</Link>
			</MenuItem>
			<MenuItem selected={option === "parts"} className="p-0">
				<Link to="/configuration/parts" className="nav-link">
					Parts
				</Link>
			</MenuItem>
		</MenuList>
		<h3 className="mes-menu-group">Locations</h3>

		<MenuList className="mes-submenu">
			<MenuItem selected={option === "locations"} className="p-0">
				<Link to="/configuration/locations" className="nav-link">
					Locations
				</Link>
			</MenuItem>
		</MenuList>
		<h3 className="mes-menu-group">Heat metrics</h3>

		<MenuList className="mes-submenu">
			<MenuItem selected={option === "ladle-heat-metrics"} className="p-0">
				<Link to="/configuration/ladle-heat-metrics" className="nav-link">
					Ladle
				</Link>
			</MenuItem>
			<MenuItem selected={option === "tundish-heat-metrics"} className="p-0">
				<Link to="/configuration/tundish-heat-metrics" className="nav-link">
					Tundish
				</Link>
			</MenuItem>
			<MenuItem selected={option === "alarms/tundishes"} className="p-0">
				<Link to="/configuration/alarms/tundishes" className="nav-link">
					Tundish Alarms
				</Link>
			</MenuItem>
			<MenuItem selected={option === "alarms/ladle-tap-temp"} className="p-0">
				<Link to="/configuration/alarms/ladle-tap-temp" className="nav-link">
					Ladle Tap Temp Alert
				</Link>
			</MenuItem>
			<MenuItem selected={option === "dress-cache"} className="p-0">
				<Link to="/configuration/dress-cache" className="nav-link">
					Dress Cache
				</Link>
			</MenuItem>
			<MenuItem selected={option === "snapshots"} className="p-0">
				<Link to="/configuration/snapshots" className="nav-link">
					Snapshots
				</Link>
			</MenuItem>
		</MenuList>
	</>
);

const customConfigurations = [components, sidebar];

export { customConfigurations };
